import { render, staticRenderFns } from "./AchievementToggle.vue?vue&type=template&id=3bac6036&scoped=true&"
import script from "./AchievementToggle.vue?vue&type=script&lang=js&"
export * from "./AchievementToggle.vue?vue&type=script&lang=js&"
import style0 from "./AchievementToggle.vue?vue&type=style&index=0&id=3bac6036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bac6036",
  null
  
)

export default component.exports